<script setup lang="ts">
import { useThemeStore } from '@clevver/stores/theme.store'
import SunIcon from '@clevver/assets/icons/sun.svg'
import MoonIcon from '@clevver/assets/icons/moon.svg'
const theme = useThemeStore()
</script>

<template>
  <button type="button" class="theme-toggle" :title="theme.mode === 'dark' ? 'Light mode' : 'Dark mode'"
          @click="theme.toggle()">
    <component :is="theme.mode === 'dark' ? SunIcon : MoonIcon" :size="17" />
  </button>
</template>

<style lang="scss" scoped>
.theme-toggle {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: 1px solid var(--c-line);
  background: transparent;
  color: var(--c-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.08s ease, border-color 0.12s;

  &:active {
    transform: scale(0.97);
  }

  &:hover {
    border-color: var(--c-line-strong);
    color: var(--c-fg);
  }
}
</style>
